import {useResourcesToken} from '@/di/di.root-container.hooks';

import cn from 'classnames';

import {Image} from '@/ui/kit/Image/Image';

import s from './MainGifts.module.css';

interface Props {
  className?: string;
}

export function MainGifts({className}: Props): JSX.Element {
  const {title, bgImages, gifts} = useResourcesToken().content.MainGifts;

  return (
    <section className={cn(s.root, className)}>
      <div className={s.bgImageWrapper}>
        <Image src={bgImages.mobile} alt={bgImages.alt} className={cn(s.bgImage, s.bgImageMobile)} />
        <Image src={bgImages.desktop} alt={bgImages.alt} className={cn(s.bgImage, s.bgImageDesktop)} />
      </div>
      <h2 className={s.title}>{title}</h2>
      <ul className={s.gifts}>
        {gifts.map(({image, title, subtitle}) => (
          <li key={title} className={s.gift}>
            <div className={s.imageWrapper}>
              <Image src={image} alt={title} className={s.image} />
            </div>
            <div className={s.content}>
              <h3 className={s.giftTitle}>{title}</h3>
              <p className={s.giftSubtitle}>{subtitle}</p>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
